





























import {enumIconName, iconsForEstateType} from '@/icons';
import {EstimateEstateType} from '@/model/api';
import {isString} from 'lodash-es';
import {Inject, Mixins} from 'vue-property-decorator';
import {Component, Prop} from 'vue-property-decorator';
import ChoiceControl from './ChoiceControl.vue';
import Control from './Control';
import {ChoiceOption, EnumControlValue, EnumOption} from './values';

@Component({
    components: {ChoiceControl},
    watch: {
        selectedValue: 'updateValue',
        customValue: 'updateValue',
    },
})
export default class EnumControl extends Mixins<Control<EnumControlValue>>(Control) {
    /** Make enum part of class */
    public Option = Option;

    @Inject()
    public readonly estateType: EstimateEstateType;

    @Prop({type: Array, required: true})
    public readonly options: EnumOption[];

    @Prop({type: String, required: true})
    public readonly parameterId: string;

    @Prop({type: Array, required: true})
    public readonly customValueOptions: EnumOption[];

    private selectedValue: ChoiceOption | null = null;

    private customValue: string = '';

    private readonly icons = iconsForEstateType(this.estateType);

    protected get selectOptions(): ChoiceOption[] {
        return this.options.map(option => ({
          icon: enumIconName(this.parameterId, option),
          value: option,
          label: this.$tc(`parameters.${this.parameterId}.options.${option}`),
        }));
    }

    public created(): void {
        const value = this.value;

        if (value === null) {
            return;
        }

        let selectedOption: string;

        if (isString(value)) {
            selectedOption = value;
        } else {
            this.customValue = value.customValue;
            selectedOption = value.option;
        }

        for (const option of this.selectOptions) {
            if (option.value === selectedOption) {
                this.selectedValue = option;
                break;
            }
        }
    }

    protected validateCurrentValue(): boolean {
        const value = this.getValue();

        return value === null || (!this.isCustomValueOptionSelected() || this.customValue.trim() !== '');
    }

    protected getValue(): EnumControlValue | null {
        const value = this.selectedValue?.value;

        if (value === undefined) {
            return null;
        }

        if (this.customValueOptions.includes(value)) {
            return {
                option: value,
                customValue: this.customValue.trim(),
            };
        }

        return value;
    }

    protected hasIcons(): boolean {
        return this.selectOptions.some(option => option.icon in this.icons);
    }

    private isCustomValueOptionSelected(): boolean {
        return this.selectedValue != null && this.customValueOptions.includes(this.selectedValue.value);
    }
}
